import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import { useSidebarNav } from './sidebarNavContext';

const menuGroup = 'list-none p-0 m-0 border-b pb-2.5';
const menuGroupNoDivider = 'border-b-0 !mb-0';
const menuGroupTitle = 'px-5 text-sm select-none w-full pt-2.5';

/**
 * groups a set of sidebar links under a title, with an optional bottom divider
 * @param title - label shown above the links
 * @param divider - whether to draw the separator under the group
 * @param children - the MenuLink/Dropdown nodes of the group
 */
function MenuGroup({ title, divider = true, children }) {
  const { isDarkPanel } = useSidebarNav();

  return (
    <ul
      className={cn(
        menuGroup,
        isDarkPanel ? 'border-white/15' : 'border-grey-lightest',
        !divider && menuGroupNoDivider
      )}
    >
      <li
        className={cn(
          menuGroupTitle,
          isDarkPanel ? 'text-white/50' : 'text-grey-light'
        )}
      >
        {title}
      </li>
      <SimpleContainer className='gap-2.5'>{children}</SimpleContainer>
    </ul>
  );
}

MenuGroup.propTypes = {
  children: propTypes.any,
  title: propTypes.string,
  divider: propTypes.bool
};

export default MenuGroup;
